import { decodeJwt } from './jwt';
import type { IdentityUser } from '../providers';

export const extractCustomerKeyFromAccessToken = (token: string) => {
    try {
        const decodedToken = decodeJwt<IdentityUser>(token)?.payload as IdentityUser;

        return decodedToken?.customerprofileid ? `${decodedToken?.customerprofileid}` : '';
    } catch {
        return '';
    }
};
